import React from 'react';

const Connectwithus = ({ address, business }) => {
  return (
    <div>
      <h3>Connect with us</h3>
      <div>
        {business?.facebook && (
          <a href={business.facebook} target="_blank" rel="noreferrer">
            Facebook
          </a>
        )}
        {business?.instagram && (
          <a href={business.instagram} target="_blank" rel="noreferrer" className="ms-2">
            Instagram
          </a>
        )}
        {business?.linkedin && (
          <a href={business.linkedin} target="_blank" rel="noreferrer" className="ms-2">
            LinkedIn
          </a>
        )}
      </div>
    </div>
  );
};

export default Connectwithus;
